import { Chrome } from 'vue-color';
import { ToggleButton } from 'vue-js-toggle-button';

if($('#editable-pricing').length){
    var app = new Vue({
        el: '#editable-pricing',
        data: {
            solo:'£19k',
            core:'£29k',
            pro:'£39k',
            openColorPicker:false,
            colour:'#E67676',
            showPricing: true,
            netZero: false
        },
        methods: {
            updateColour(colours){
                this.colour = colours.hex;
            },
        },
        components: {
            'chrome-picker': Chrome,
            'ToggleButton': ToggleButton,
        },
    });
}